import TableAccordion from "../../../../../../../components/AutomatedCredit/CreditAnalysis/Components/TableAccordion";
import { TextEditor } from "../../../../../../../components/AutomatedCredit/CreditAnalysis/Components/TextEditor";

import styles from "./loanPurpose.module.scss";

interface ILoanPurpose {
  defaultValue: string;
  handleChange: any;
}

const LoanPurpose = ({ defaultValue, handleChange }: ILoanPurpose) => {
  return (
    <div className={styles.CreditScoreComments}>
      <TableAccordion
        title={<span className={styles.Title}>LOAN PURPOSE</span>}
        isDefaultOpen
      >
        <TextEditor onChange={handleChange} defaultValue={defaultValue} />
      </TableAccordion>
    </div>
  );
};

export default LoanPurpose;
